export const UserRoles = {
    SUPERUSER: 'Superuser',
    SYSTEMADMIN: 'SystemAdmin', // hospital
    COMPANYADMIN: 'CompanyAdmin',
    FACILITYADMIN: 'FacilityAdmin', // clinic
    USER: 'User', // therapist
    ENDUSER: 'EndUser', // patient
}